import { withProps } from 'recompose';
import ObjectInput from '@/se/components/inputs/ObjectInput';
import ToggleInput from '@/se/components/inputs/ToogleInput';

export default withProps({
  schema: {
    isHideLiaisonScreen: withProps({ label: 'Hide room on Liaison screen' })(ToggleInput),
  },
})(ObjectInput);
